/**
 * @generated SignedSource<<bcb7690e23148e335eaa967f62e38472>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Currency = "CAD" | "EUR" | "GBP" | "USD";
import { FragmentRefs } from "relay-runtime";
export type ClubCurrencyContextFragment$data = {
  readonly currency: Currency;
  readonly " $fragmentType": "ClubCurrencyContextFragment";
};
export type ClubCurrencyContextFragment$key = {
  readonly " $data"?: ClubCurrencyContextFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClubCurrencyContextFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClubCurrencyContextFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "0f429df1826350b33992d16798979e46";

export default node;
